import { FeatureFlags } from 'types/config';

export type Language = 'en' | 'ru' | 'es';

export enum UserType {
  User = 'USER',
}

export type Currency = 'USD' | 'RUB' | 'UTT';

export interface Money {
  value: number;
  currency: string;
  exp?: number | null;
}
export interface MoneyV2 {
  value: string;
  currency: {
    code: string;
  };
}

export enum SagaContext {
  KeycloakService = 'keycloakService',
  ApolloClient = 'apolloClient',
}

export interface GTMData {
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
}

declare global {
  interface Window {
    ga: any;
    dataLayer?: {
      push: (value: {}) => void;
    };
  }
}

export interface UrlQuery {
  featureFlags?: { [key in keyof FeatureFlags]: string };
  recoverPassword?: boolean;
}

export enum CookieKeys {
  KYCNotifyHidden = 'kycNotifyHidden',
}
